import React from 'react';
import styled from 'styled-components';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';
import ModalIconTitle from 'features/POSRegisters/components/ModalContent/components/ModalTitle';
import ModalMainContentContainer from './components/ModalContentContainer';
import {AdaptedDeviceData} from 'features/POSRegisters/interfaces/AdaptedDeviceData';
import UnsupportedDeviceMessage from '../UnsupportedDeviceMessage';

//#region Styled Components
const StyledModalContent = styled.div``;

//#endregion Styled Components

//#region Component
interface ModalContent {
  deviceType: DeviceType;
  adaptedDeviceData: AdaptedDeviceData<ScanDetails> | null;
}

export default function UnsupportedModalContent({deviceType, adaptedDeviceData}: ModalContent) {
  return (
    <StyledModalContent>
      <ModalIconTitle deviceType={deviceType} deviceName={adaptedDeviceData?.id}>
        <></>
      </ModalIconTitle>

      <ModalMainContentContainer>
        <UnsupportedDeviceMessage deviceType={deviceType} />
      </ModalMainContentContainer>
    </StyledModalContent>
  );
}
//#endregion Component
